import { IntlFormatters } from 'react-intl'
import * as yup from 'yup'

export const generateSchema = (f: IntlFormatters['formatMessage']) => {
  return yup.object().shape({
    name: yup.string().required(
      f({
        id: 'onboarding.errorMessage.requiredName',
        defaultMessage: 'Please fill your name',
      }),
    ),
    child_dob: yup.date().required(
      f({
        id: 'bmi.ageInput.error',
        defaultMessage: 'Please enter a valid age',
      }),
    ),
    phone: yup
      .string()
      .required(
        f({
          id: 'carePathLead.form.requiredPhone',
          defaultMessage: 'Please provide your phone number',
        }),
      )
      .min(12, f({ id: 'onboarding.updatePhone.error' }))
      .max(15, f({ id: 'onboarding.updatePhone.error' })),
    term: yup
      .bool()
      .required(f({ id: 'onboarding.friso.term.error' }))
      .oneOf([true], f({ id: 'onboarding.friso.term.error' })),
  })
}
